import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyC-P83qjoit348D-lEtSfMFUI9P_zHsNtw",
  authDomain: "jskmtechnologies.firebaseapp.com",
  databaseURL: "https://jskmtechnologies-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "jskmtechnologies",
  storageBucket: "jskmtechnologies.firebasestorage.app",
  messagingSenderId: "279986026799",
  appId: "1:279986026799:web:5fbcba0f9d75a475f589da",
  measurementId: "G-QZPXX2392B"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app); 
